import bilAPI from '../api';

export const getSchoolAcceptances = (params, signal) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/school_acceptance/', { params, signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchSchoolAcceptance = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/results/school_acceptance/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getSchoolAcceptanceMyPlace = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/school_acceptance/my_place/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getAcceptanceStats = (params, signal) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/school_acceptance_stats_api/', { params, signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
